import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import KeyData from "@/components/KeyData";

export default function RevealChapter() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.post("/reveal/generate").then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <Loading />;

  const md = data.chart.current_mahadasha;
  const ad = data.chart.current_antardasha;
  const startDate = new Date(ad.start_date);
  const endDate = new Date(ad.end_date);
  const now = new Date();
  const totalDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
  const elapsed = Math.max(0, Math.floor((now - startDate) / (1000 * 60 * 60 * 24)));
  const remaining = Math.max(0, totalDays - elapsed);
  const pct = totalDays ? Math.min(100, (elapsed / totalDays) * 100) : 0;

  return (
    <div className="min-h-screen flex flex-col px-6 py-10 max-w-md mx-auto" style={{ color: "var(--vedari-ink)" }}>
      <p className="text-caption tracking-[0.25em] uppercase" style={{ color: "var(--vedari-gold)" }} data-testid="chapter-eyebrow">
        Your Current Chapter
      </p>

      <div className="flex-1 flex flex-col items-center justify-center text-center py-12">
        <h2 className="font-display text-3xl mb-3" data-testid="chapter-name">
          <KeyData>{md.planet}</KeyData>–<KeyData>{ad.antardasha}</KeyData>
        </h2>
        <p className="text-body-sm" style={{ color: "var(--vedari-ink-soft)" }}>Antardasha</p>

        <div className="my-10">
          <p className="text-caption uppercase tracking-widest mb-3" style={{ color: "var(--vedari-ink-soft)" }}>Days remaining</p>
          <p className="font-display text-[64px] leading-none countdown-alive" style={{ color: "var(--vedari-gold)" }} data-testid="chapter-countdown">
            {remaining}
          </p>
        </div>

        <div className="w-full max-w-xs">
          <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: "var(--vedari-divider)" }}>
            <div className="h-full transition-all duration-700" style={{ width: `${pct}%`, backgroundColor: "var(--vedari-gold)" }} />
          </div>
          <div className="flex justify-between mt-2 text-caption" style={{ color: "var(--vedari-ink-soft)" }}>
            <span><KeyData>{elapsed}</KeyData> walked</span>
            <span><KeyData>{Math.round(pct)}%</KeyData> through</span>
          </div>
        </div>

        <p className="text-body-lg leading-relaxed mt-12 font-serif italic max-w-xs" style={{ color: "var(--vedari-ink-soft)" }}>
          {chapterTheme(md.planet, ad.antardasha)}
        </p>
      </div>

      <button onClick={() => navigate("/reveal/glimpses")} className="vedari-btn-primary w-full mt-6" data-testid="chapter-continue-btn">
        What does this phase ask?
      </button>
    </div>
  );
}

function chapterTheme(m, a) {
  return `A time when ${planetWord(m)} meets ${planetWord(a)}. The chapter rewards patience and pointed attention.`;
}
function planetWord(p) {
  const w = { Ketu: "release", Venus: "tenderness", Sun: "clarity", Moon: "emotional depth",
    Mars: "directed action", Rahu: "expansion", Jupiter: "wisdom", Saturn: "discipline", Mercury: "articulation" };
  return w[p] || p;
}

function Loading() {
  return <div className="min-h-screen flex items-center justify-center"><span className="animate-soft-pulse" style={{ color: "var(--vedari-ink-soft)" }}>A moment…</span></div>;
}
